import FloatingConnectionLine from "./FloatingConnectionLine";
import FloatingEdge from "./FloatingEdge";

const CustomEdges = {
  floating: FloatingEdge,
};

export { CustomEdges, FloatingConnectionLine, FloatingEdge };
